module.exports = __webpack_public_path__ + "static/media/history_33.423e2d44.jpg";